import { ReactNode } from "react"

interface EmptyListProps {
  title: string
  description: string
  cta?: ReactNode
}

export function EmptyList({ title, description, cta }: EmptyListProps) {
  return (
    <div className="py-16 text-center">
      <h2 className="mb-2 text-xl font-semibold">{title}</h2>
      <p className="mx-auto mb-6 max-w-md text-muted-foreground">{description}</p>
      {cta && <div>{cta}</div>}
    </div>
  )
}
